<style lang="scss" scoped>
.wonde-client-versions {
	&__version {
		margin-bottom: 0;
	}
	&__date {
		font-size: 0.9em;
	}
	&__current {
		margin-left: 10px;
	}
	&__header {
		@include flex-center;
	}
	&__item {
		margin-bottom: 20px;
	}
}
.el-collapse {
	border-top: none;
	.el-collapse-item__content {
		padding-bottom: none;
	}
}
</style>

<template lang="pug">
.wonde-client-versions
	empty(v-if="!$apollo.loading && !Releases.length") No release information found
	template(v-else)
		el-collapse(accordion, v-loading='$apollo.loading')
			el-collapse-item(v-for="r in Releases", :key="r.id", :title="r.release")
				template(slot='title')
					.wonde-client-versions__header
						h4.wonde-client-versions__version {{ 'v' + r.release }} 
						el-tag.wonde-client-versions__current(v-if="currentRelease(r.release)", size="mini", type='success') Current
				.wonde-client-versions__item
					p.wonde-client-versions__date {{ r.released_at | standard_date }}
					div(v-html="r.description")
</template>

<script>
import gql from "graphql-tag";

export default {
	name: "WondeClientReleases",
	props: {
		release: {
			type: String
		}
	},
	methods: {
		currentRelease(release) {
			return release === this.release;
		}
	},
	apollo: {
		Releases: {
			query: gql`
				query Releases($type: String) {
					Releases(type: $type) {
						id
						type
						release
						description
						released_at
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			variables() {
				return {
					type: "wonde_client"
				};
			}
		}
	}
};
</script>
